// La ÚNICA escala de elevación del detalle (revisión del PO, pasada 25).
//
// El diálogo tenía cuatro grises de DOS FAMILIAS INCOMPATIBLES: dos opacos (`background.card` en la
// banda de cabecera, `background.paper` en la columna de bloques) y dos superpuestos en blanco
// (`alpha(text.primary, 0.03)` en las tarjetas, `0.04` en el marco de la foto). Un gris superpuesto
// toma el tono de lo que tiene debajo y uno opaco no, así que los mismos dos valores se separan o se
// juntan según el contexto: de ahí que la columna de bloques cantara contra las tarjetas.
//
// Se elige la familia OPACA, que es la que usa el resto de MIC fuera del diálogo, y se reduce a
// TRES niveles. Todos son tokens del
// tema (`src/themeConfig.js`), nunca colores escritos a mano:
//
//   ground  `background.card`         el fondo de la ventana y de la zona de contenido
//   raised  `background.row2`         toda superficie que se levanta: tarjetas, columna de bloques,
//                                     cabeceras de tabla, filas desplegadas
//   sunken  `background.color_212121`  lo que se hunde: los campos editables
//
// (Sus valores viven en `src/themeConfig.js`, palette.background — aquí no se escribe ninguno.)
//
// Nota sobre `background.paper`: SÍ es un token declarado del tema (`themeConfig.js:17`), no el
// `grey[800]` por defecto de MUI que aparentaba ser — coinciden en valor, pero está elegido. Aun
// así, contra el fondo del diálogo salta demasiado —era la queja del PO— y aquí no se usa. Los menús y tooltips de
// MUI lo siguen usando por su cuenta; eso es cosa del tema global, no de esta escala.
//
// Los colores de acento (verde primario, azul de estado, tintes de aviso/error) NO entran en esta
// escala: son significado, no elevación.
const fallback = (...values) => values.find((value) => !!value)

export const groundColor = (theme) =>
  fallback(theme.palette.background.card, theme.palette.background.default)

export const raisedColor = (theme) =>
  fallback(theme.palette.background.row2, theme.palette.background.paper)

export const sunkenColor = (theme) =>
  fallback(theme.palette.background.color_212121, theme.palette.background.default)
